import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3796d6eb&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=3796d6eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796d6eb",
  null
  
)

export default component.exports